(() => {
  function handleize(value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getSelectedColor(gallery) {
    const product = gallery.closest('.product') || document;

    const fieldset = [...product.querySelectorAll('fieldset')].find((item) => {
      const legend = item.querySelector('legend');
      return legend && legend.textContent.trim().toLowerCase() === 'color';
    });

    const selectedRadio = fieldset?.querySelector('input[type="radio"]:checked');
    if (selectedRadio) return handleize(selectedRadio.value);

    const colorSelect = [...product.querySelectorAll('select')].find((select) => {
      const label = product.querySelector(`label[for="${select.id}"]`);
      return label?.textContent.trim().toLowerCase() === 'color';
    });

    return colorSelect ? handleize(colorSelect.value) : '';
  }

  function filterGallery(gallery) {
    const selectedColor = getSelectedColor(gallery);
    if (!selectedColor) return;

    const coloredItems = [...gallery.querySelectorAll('[data-media-color]')];
    const matchingItems = coloredItems.filter(
      (item) => item.dataset.mediaColor === selectedColor
    );

    if (!matchingItems.length) return;

    coloredItems.forEach((item) => {
      item.hidden = item.dataset.mediaColor !== selectedColor;
    });

    const firstThumbnail = gallery.querySelector(
      `[data-media-color="${selectedColor}"][data-target] button`
    );

    if (firstThumbnail) {
      firstThumbnail.click();
    }
  }

  function filterAllGalleries() {
    document.querySelectorAll('media-gallery').forEach(filterGallery);
  }

  document.addEventListener('DOMContentLoaded', filterAllGalleries);

  document.addEventListener('change', (event) => {
    if (
      event.target.matches('input[type="radio"]') ||
      event.target.matches('select')
    ) {
      filterAllGalleries();
    }
  });

  document.addEventListener('shopify:section:load', filterAllGalleries);
})();